<template lang="pug">
form.searchBox__inputbox.d-flex.align-items-center.gap-2.ps-4(@submit.prevent="handleSubmit")
  label(for="query" class="visually-hidden") Search
  span.searchBox__iconContainer.d-flex.align-items-center.justify-content-center
    EcreativAtomsSvgIcon.searchBox__icon(iconName="search", iconSize="md", isCustom)
  input.searchBox__input.ps-2.p-2(
    type="text"
    id="query"
    :value="modelValue"
    @input="onInput"
    placeholder="Search True Islam"
    aria-label="Search"
  )
</template>

<script setup lang="ts">
defineProps<{
  modelValue: string;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void;
  (e: 'submit'): void;
}>();

function handleSubmit() {
  emit('submit');
}

function onInput(event: Event) {
  const target = event.target as HTMLInputElement;
  emit('update:modelValue', target.value);
}
</script>

<style scoped lang="scss">
.searchBox__inputbox {
  flex: 1 1 25%;
  min-height: 55px;
  border-right: 1px solid #ccc;
  border-top-left-radius: 55px;
  border-bottom-left-radius: 55px;
  background: #f5f5f7;
}

.searchBox__input {
  flex-grow: 1;
  width: 80%;
  border: 0;
  background: transparent;
  outline: none;
}
</style>
